import { render, staticRenderFns } from "./company-create-success.vue?vue&type=template&id=3c3f4a9e&"
import script from "./company-create-success.vue?vue&type=script&lang=js&"
export * from "./company-create-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports